<template lang='pug'>
v-dialog(scrollable max-width='400px' v-model='dialog' persistent lazy)
  v-card(class='combo-card')
    v-card-title
      v-text-field(
        :loading='isLoading'
        ref='search'
        @input='onSearch'
        prepend-inner-icon='search'
        label='Поиск'
        hide-details
        clearable
      )
    v-card-text(style='height: 300px')
      v-list(class='multiple-select')
        v-radio-group(v-model='selected' )
          v-radio(v-for='item in list' :key='item.id' :value='item.guid' :label='item.name' color='primary')
    v-card-actions
      v-spacer
      v-btn(flat @click='$emit("close")') Отмена
      v-btn(
        flat
        :disabled='!selected'
        color='primary'
        @click='$emit("select", selectedClient)'
      ) Ok
</template>

<script>
import http from '@/http'
import { debounce, find } from 'lodash'

export default {
  props: ['dialog'],

  data: () => ({
    search: null,
    selected: null,
    count: 50,
    list: [],
    isLoading: false
  }),

  mounted() {
    if (this.dialog) {
      this.fetch()
    }
  },

  methods: {
    debouncedFetch: debounce(function() {
      let { search, count } = this
      this.fetchList({ search, count })
    }, 250),

    async fetchList(params) {
      try {
        this.isLoading = true
        this.list = (await http.get('/admin/allclients', { params })).data.data
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить список клиентов')
      } finally {
        this.isLoading = false
      }
    },

    onSearch(search) {
      this.search = search
    }
  },

  watch: {
    dialog(opened) {
      if (opened) {
        this.debouncedFetch()

        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      } else {
        this.list = []
        this.selected = null
      }
    },

    search() {
      this.debouncedFetch()
    }
  },

  computed: {
    selectedClient() {
      return find(this.list, {
        guid: this.selected
      })
    }
  }
}
</script>

<style scoped>
.combo-card {
  height: 100%;
}
.combo-card >>> .v-list__tile__sub-title,
.combo-card >>> .v-list__tile__title {
  white-space: unset;
}
</style>
